module.exports = __webpack_public_path__ + "images/ico-usergreen-act.svg?467617fe647b1d2c47ca916211db8887";